import React from 'react';
import TransactionsHistoryContainer from '@src/containers/EarningsManagement/TransactionsHistory';

const TransactionsHistory = () => <TransactionsHistoryContainer />;

export default TransactionsHistory;
